import { render, staticRenderFns } from "./Desempenho.vue?vue&type=template&id=61e9f22c&scoped=true"
import script from "./Desempenho.vue?vue&type=script&lang=js"
export * from "./Desempenho.vue?vue&type=script&lang=js"
import style0 from "./Desempenho.vue?vue&type=style&index=0&id=61e9f22c&prod&lang=css"
import style1 from "./Desempenho.vue?vue&type=style&index=1&id=61e9f22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e9f22c",
  null
  
)

export default component.exports